<template>
  <div class="notes_board_main_wrp">
    <!-- Notes list -->
    <div v-if="activeView === 'list'" class="todo_content_inner_wrp all_notes_list_wrp">
      <div class="todo_notes_header_wrp">
        <div class="row align-items-center">
          <div class="col">
            <button
              type="button"
              class="todo_notes_insert_icon icon_button"
              aria-label="Create a new note"
              :disabled="submitted"
              @click="newInsertesNotesBoardMethod"
            >
              <i class="fa fa-plus" aria-hidden="true"></i>
            </button>
          </div>

          <div class="col-auto ml-auto">
            <div class="shared_notes_toolbar">
              <button
                type="button"
                class="btn btn-primary"
                :disabled="isLoadingShared"
                @click="showSharedUserListMethod"
              >
                {{ sharedNotesSection ? 'My Notes' : 'Shared Notes' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <ul v-if="sharedNotesSection" class="notes_list_items shared_notes_list_wrp">
        <li v-if="isLoadingShared" class="notes_loading_state">
          <img src="@/assets/images/progressbar.gif" class="img-fluid" alt="Loading shared notes">
        </li>

        <template v-else-if="allSharedNotesResults.length">
          <li v-for="(entry, index) in allSharedNotesResults" :key="sharedEntryKey(entry)">
            <button
              type="button"
              class="notes_item_button"
              :disabled="submitted"
              @click="handleSharedNoteSelection(entry, false)"
            >
              <span class="notes_title_span">
                <i class="fa">{{ index + 1 }}.</i>
                {{ getSharedNoteTitle(entry.item) }}
              </span>
              <span class="notes_created_date">
                {{ getSharedNoteCreatedAt(entry.item) | dateformat }}
              </span>
              <span class="shared_notes_user_name">{{ getSharedNoteOwnerName(entry.item) }}</span>
              <label v-if="entry.item.is_read === false" class="new_notes_label">New</label>
            </button>
          </li>
        </template>

        <li v-else class="alert_msg_shared_notes notes_empty_state">
          You don't have any shared notes
        </li>
      </ul>

      <ul v-else class="notes_list_items">
        <li v-if="isLoadingNotes" class="notes_loading_state">
          <img src="@/assets/images/progressbar.gif" class="img-fluid" alt="Loading notes">
        </li>

        <template v-else-if="visibleOwnNotes.length">
          <li v-for="noteItems in visibleOwnNotes" :key="noteItems.id">
            <button
              type="button"
              class="notes_list_itemwrp notes_item_button"
              :disabled="submitted"
              @click="updatedNotesDetailsByIdmethod(noteItems.id)"
            >
              <span class="notes_title_span">
                <i class="fa fa-pencil" aria-hidden="true"></i>
                <span class="note_html_title">{{ noteItems.title }}</span>
              </span>
              <span class="notes_created_date">{{ noteItems.created_at | dateformat }}</span>
            </button>

            <span class="notes_sharing_icon">
              <button
                type="button"
                class="icon_button"
                aria-label="Share note"
                :disabled="submitted"
                @click.stop="sharedNotesPopupEnabledFun(noteItems)"
              >
                <i class="fa fa-share-alt" aria-hidden="true"></i>
              </button>
            </span>
          </li>
        </template>

        <li v-else class="notes_empty_state">
          {{ noteCloseState ? 'No Data Found' : 'You do not have any notes yet' }}
        </li>
      </ul>
    </div>

    <!-- Create note / shared notes landing -->
    <div v-else-if="activeView === 'create'" class="todo_content_inner_wrp new_inserted_notes_board_wrp">
      <div class="todo_notes_header_wrp text-right">
        <template v-if="!notesBoardInsert">
          <div class="shared_toolbar_inline">
            <div class="shared_notes_toolbar">
              <button
                type="button"
                class="btn btn-primary"
                :disabled="isLoadingShared"
                @click="showSharedUserListNewMethod"
              >
                {{ coreSharedNotesSection ? 'My Notes' : 'Shared Notes' }}
              </button>
            </div>
          </div>

          <button
            type="button"
            class="todo_notes_insert_icon icon_button"
            aria-label="Write a new note"
            @click="notesBoardInsertMethod"
          >
            <img src="@/assets/images/edit_profile.png" class="add_new_notes" width="22" alt="">
          </button>
        </template>

        <button
          v-else
          type="button"
          class="todo_notes_insert_icon icon_button"
          aria-label="Save note"
          :disabled="submitted"
          @click="savedInsertedNotesDataMethod"
        >
          <i class="fa fa-check" aria-hidden="true"></i>
        </button>
      </div>

      <ul v-if="coreSharedNotesSection" class="notes_list_items shared_notes_list_wrp">
        <li v-if="isLoadingShared" class="notes_loading_state">
          <img src="@/assets/images/progressbar.gif" class="img-fluid" alt="Loading shared notes">
        </li>

        <template v-else-if="allSharedNotesResults.length">
          <li v-for="(entry, index) in allSharedNotesResults" :key="sharedEntryKey(entry)">
            <button
              type="button"
              class="notes_item_button"
              :disabled="submitted"
              @click="handleSharedNoteSelection(entry, true)"
            >
              <span class="notes_title_span">
                <i class="fa">{{ index + 1 }}.</i>
                {{ getSharedNoteTitle(entry.item) }}
              </span>
              <span class="notes_created_date">
                {{ getSharedNoteCreatedAt(entry.item) | dateformat }}
              </span>
              <span class="shared_notes_user_name">{{ getSharedNoteOwnerName(entry.item) }}</span>
              <label v-if="entry.item.is_read === false" class="new_notes_label">New</label>
            </button>
          </li>
        </template>

        <li v-else class="alert_msg_shared_notes notes_empty_state">
          You don't have any shared notes
        </li>
      </ul>

      <div v-else class="no_notes_msg_wrp">
        <div v-if="notesBoardInsert" class="notes_textarea_wrp note_for_textarea_styling">
          <input
            v-model.trim="createNotesTitle"
            type="text"
            class="title_insert_notes_textarea"
            autofocus
            maxlength="255"
            placeholder="Title..."
          >
          <vue-editor
            v-model="createNotesData"
            :editor-toolbar="customToolbar"
            :config="editorOptions"
            placeholder="Description..."
          ></vue-editor>
        </div>

        <h5 v-else class="no_notes_msg">
          Write out your thoughts, dreams <br> and ideas here on lymphomap’s notes page.
        </h5>
      </div>
    </div>

    <!-- Editable note view -->
    <div
      v-else-if="isEditableView"
      class="todo_content_inner_wrp note_details_by_id_wrp"
      :class="editableViewClass"
    >
      <div class="todo_notes_header_wrp">
        <div class="row">
          <div class="col-auto ml-auto">
            <button
              type="button"
              class="todo_notes_insert_icon icon_button"
              :aria-label="activeView === 'my-edit' ? 'Create a new note' : 'Back to shared notes'"
              :disabled="submitted"
              @click="handleEditorBack"
            >
              <i
                class="fa"
                :class="activeView === 'my-edit' ? 'fa-plus' : 'fa-arrow-left'"
                aria-hidden="true"
              ></i>
            </button>
          </div>

          <div class="col text-right">
            <button
              type="button"
              class="todo_notes_insert_icon icon_button"
              aria-label="Expand note"
              @click="enabledNotesViewPopupMethod(activeNote)"
            >
              <i class="fa fa-expand" aria-hidden="true"></i>
            </button>

            <button
              type="button"
              class="todo_notes_insert_icon icon_button"
              aria-label="Download note as PDF"
              :class="{ active: notesConvertPdfState }"
              @click="enabledConvertedPdfPopupMethod(activeNote)"
            >
              <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
            </button>

            <button
              v-if="activeView === 'my-edit'"
              type="button"
              class="todo_notes_insert_icon icon_button"
              aria-label="Delete note"
              :disabled="submitted"
              @click="removedInsertedNotesDataMethod(activeNote.id)"
            >
              <i class="fa fa-trash" aria-hidden="true"></i>
            </button>

            <button
              v-if="activeView === 'shared-edit'"
              type="button"
              class="todo_notes_insert_icon icon_button"
              aria-label="Back to my notes"
              :disabled="submitted"
              @click="backToMyNotesList"
            >
              <i class="fa fa-align-right" aria-hidden="true"></i>
            </button>

            <button
              type="button"
              class="todo_notes_insert_icon icon_button"
              aria-label="Finish editing"
              :disabled="submitted"
              @click="handleEditorDone"
            >
              <i class="fa fa-check" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="no_notes_msg_wrp">
        <div class="notes_textarea_wrp note_for_textarea_styling">
          <template v-if="isActiveNoteLocked">
            <span class="currently_updating_txt">
              {{ activeNote.edited_by.first_name }} {{ activeNote.edited_by.last_name }} is currently updating the
              document. Please wait for your teammate to complete their notes, after which you can update and save
              your changes.
            </span>
            <input
              :value="activeNote.title"
              type="text"
              class="title_insert_notes_textarea"
              readonly
            >
            <div v-html="activeNote.data" class="readonly_html_note_text"></div>
          </template>

          <template v-else>
            <input
              v-model="activeNote.title"
              type="text"
              class="title_insert_notes_textarea"
              maxlength="255"
              placeholder="Title..."
              @input="markNoteDirty"
              @keyup="updatedSharedNotesNotificationMethod(activeNote.id)"
              @change="saveCurrentNote"
            >
            <vue-editor
              :key="editorKey"
              ref="activeNotesEditor"
              v-model="activeNote.data"
              :editor-toolbar="customToolbar"
              :config="editorOptions"
              placeholder="Description..."
              @input="markNoteDirty"
              @blur="saveCurrentNote"
              @focus="updatedSharedNotesNotificationMethod(activeNote.id)"
              @ready="onEditorReady"
            ></vue-editor>
          </template>
        </div>
      </div>
    </div>

    <!-- Read-only shared note -->
    <div
      v-else-if="activeView === 'read-only'"
      class="todo_content_inner_wrp shared_notes_view_wrp no_write_access_notes"
    >
      <div class="todo_notes_header_wrp">
        <div class="row align-items-center">
          <div class="col-auto">
            <button
              type="button"
              class="todo_notes_insert_icon icon_button"
              aria-label="Back to shared notes"
              @click="backToWriteAccessNotesList"
            >
              <i class="fa fa-arrow-left" aria-hidden="true"></i>
            </button>
          </div>
          <div class="col text-right">
            <span class="pr-3 no_write_access_label">
              <i class="fa fa-ban" aria-hidden="true"></i> No Write Access
            </span>
          </div>
        </div>
      </div>

      <div class="no_notes_msg_wrp">
        <div class="notes_textarea_wrp note_for_textarea_styling">
          <input :value="sharedNotesViewDetails.title" type="text" class="title_insert_notes_textarea" readonly>
          <div v-html="sharedNotesViewDetails.data" class="readonly_html_note_text pt-2"></div>
        </div>
      </div>
    </div>

    <!-- Delete confirmation -->
    <div v-if="notesRemovedPopup" class="remove_notes_task_modal" role="dialog" aria-modal="true">
      <div class="remove_notes_task_modal_body">
        <div class="remove_notes_task_header">
          <h2>This action is irreversible. Are you sure?</h2>
        </div>
        <div class="remove_notes_task_btn">
          <button
            type="button"
            class="btn remove_yes_btn"
            :disabled="submitted"
            @click="removeModalItemConfirmFun"
          >
            Yes, delete
          </button>
          <button
            type="button"
            class="btn remove_yes_no"
            :disabled="submitted"
            @click="closeRemoveItemModalFun"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>

    <notes-pdf
      v-if="notesConvertPdfState"
      v-bind:notesConvertPdfDATA="notesConvertPdfData"
    ></notes-pdf>
    <notes-share
      v-if="sharedNotesPopup"
      v-bind:sharedNotesINFO="sharedNotesInfo"
    ></notes-share>
    <notes-view
      v-if="notesViewPopup"
      v-bind:notesViewDATA="notesViewData"
    ></notes-view>
  </div>
</template>

<script>
import { Quill, VueEditor } from 'vue2-editor';
import { bus } from '@/main';
import notesConvertPdf from './notes-convert-to-pdf/index.vue';
import notesView from './notes-view-section/index.vue';
import sharedNotes from './shared-notes/index.vue';

const Font = Quill.import('formats/font');
Font.whitelist = ['arial', 'georgia', 'tahoma', 'verdana'];
Quill.register(Font, true);

const VIEW = Object.freeze({
  LIST: 'list',
  CREATE: 'create',
  MY_EDIT: 'my-edit',
  SHARED_EDIT: 'shared-edit',
  CORE_SHARED_EDIT: 'core-shared-edit',
  READ_ONLY: 'read-only'
});

export default {
  name: 'notes',

  components: {
    'notes-share': sharedNotes,
    'notes-pdf': notesConvertPdf,
    'notes-view': notesView,
    VueEditor
  },

  data() {
    return {
      activeView: VIEW.LIST,

      getAllNotesList: null,
      getAllNotesListResults: [],
      isLoadingNotes: false,
      notesListRequest: null,

      notesBoardInsert: false,
      createNotesData: '',
      createNotesTitle: '',

      notesRemovedPopup: false,
      notesRemovedId: null,

      notesDetailsUpdatedByIdData: {},
      sharedNotesViewDetails: {},
      detailRequestToken: 0,

      sharedNotesPopup: false,
      sharedNotesInfo: null,
      sharedNotesSection: false,
      coreSharedNotesSection: false,
      sharedNotesList: null,
      sharedNotesListResults: [],
      sharedGroupNotesListResults: [],
      isLoadingShared: false,
      sharedNotesRequest: null,

      selfUserId: '',
      submitted: false,

      notesConvertPdfState: false,
      notesConvertPdfData: {},
      notesViewPopup: false,
      notesViewData: null,

      editorOptions: {
        placeholder: 'Description...'
      },
      customToolbar: [
        [{ font: ['arial', 'georgia', 'tahoma', 'verdana'] }],
        ['bold', 'italic', 'underline', { color: [] }, { background: [] }]
      ],
      quillInstance: null,

      noteDirty: false,
      saveRequest: null,
      saveQueued: false,
      queuedSaveOptions: null,
      keyUpEvent: false,
      editLockRequest: null,

      notesSearchState: '',
      noteCloseState: false,
      notesSearchResults: []
    };
  },

  computed: {
    // Compatibility aliases for code that previously inspected the old view flags.
    verticalAllNotesListState: {
      get() {
        return this.activeView === VIEW.LIST;
      },
      set(value) {
        if (value) this.setActiveView(VIEW.LIST);
      }
    },

    insertedNewNotesBoard: {
      get() {
        return this.activeView === VIEW.CREATE;
      },
      set(value) {
        if (value) this.setActiveView(VIEW.CREATE);
      }
    },

    notesDetailsUpdatedByIDstate: {
      get() {
        return this.activeView === VIEW.MY_EDIT;
      },
      set(value) {
        if (value) this.setActiveView(VIEW.MY_EDIT);
      }
    },

    sharedNotesViewSection: {
      get() {
        return this.activeView === VIEW.SHARED_EDIT;
      },
      set(value) {
        if (value) this.setActiveView(VIEW.SHARED_EDIT);
      }
    },

    coreSharedNotesViewSection: {
      get() {
        return this.activeView === VIEW.CORE_SHARED_EDIT;
      },
      set(value) {
        if (value) this.setActiveView(VIEW.CORE_SHARED_EDIT);
      }
    },

    writeAccessSharedNotesViewSection: {
      get() {
        return this.activeView === VIEW.READ_ONLY;
      },
      set(value) {
        if (value) this.setActiveView(VIEW.READ_ONLY);
      }
    },

    isEditableView() {
      return [VIEW.MY_EDIT, VIEW.SHARED_EDIT, VIEW.CORE_SHARED_EDIT].indexOf(this.activeView) !== -1;
    },

    activeNote() {
      return this.activeView === VIEW.MY_EDIT
        ? this.notesDetailsUpdatedByIdData
        : this.sharedNotesViewDetails;
    },

    editorKey() {
      return this.activeView + '-' + (this.activeNote.id || 'new');
    },

    editableViewClass() {
      if (this.activeView === VIEW.SHARED_EDIT) return 'shared_notes_view_wrp';
      if (this.activeView === VIEW.CORE_SHARED_EDIT) return 'core_shared_notes_view_wrp';
      return '';
    },

    isActiveNoteLocked() {
      const editedBy = this.activeNote && this.activeNote.edited_by;
      return Boolean(
        this.activeNote &&
        this.activeNote.under_editing &&
        editedBy &&
        String(editedBy.id) !== String(this.selfUserId)
      );
    },

    allSharedNotesResults() {
      const personal = this.sharedNotesListResults.map((item) => ({ item, isGroup: false }));
      const groups = this.sharedGroupNotesListResults.map((item) => ({ item, isGroup: true }));
      return personal.concat(groups);
    },

    visibleOwnNotes() {
      return this.noteCloseState ? this.notesSearchResults : this.getAllNotesListResults;
    },

    isBodyScrollLocked() {
      return this.notesRemovedPopup || this.notesViewPopup || this.sharedNotesPopup;
    }
  },

  watch: {
    isBodyScrollLocked: {
      immediate: true,
      handler(locked) {
        this.setBodyScrollLocked(locked);
      }
    },

    editorKey() {
      this.$nextTick(this.clearEditorHistory);
    }
  },

  mounted() {
    this.selfUserId = localStorage.getItem('LoginedUserID') || '';
    this.getAllCreatedNotesListMethod();

    bus.$on('notesViewPopupBus', this.handleNotesViewPopupBus);
    bus.$on('sharedNotesBus', this.handleSharedNotesBus);
    bus.$on('notesConvertPdfStateBus', this.handleNotesConvertPdfStateBus);
  },

  beforeDestroy() {
    bus.$off('notesViewPopupBus', this.handleNotesViewPopupBus);
    bus.$off('sharedNotesBus', this.handleSharedNotesBus);
    bus.$off('notesConvertPdfStateBus', this.handleNotesConvertPdfStateBus);

    this.setBodyScrollLocked(false);

    if (this.isEditableView && this.activeNote && this.activeNote.id) {
      this.releaseEditingLock(this.activeNote.id, true);
    }
  },

  methods: {
    getResponseData(response, fallback) {
      if (response && response.data && response.data.data !== undefined) {
        return response.data.data;
      }
      return fallback;
    },

    toArray(value) {
      return Array.isArray(value) ? value : [];
    },

    reportError(context, error) {
      // Keep component independent from any specific toast plugin.
      // The parent application can replace this with its preferred notifier.
      // eslint-disable-next-line no-console
      console.error('[Notes] ' + context, error);
    },

    setBodyScrollLocked(locked) {
      if (typeof document === 'undefined' || !document.body) return;
      document.body.classList.toggle('body_right_scroll_remove', Boolean(locked));
    },

    setActiveView(view) {
      this.activeView = view;
    },

    sharedEntryKey(entry) {
      const item = entry && entry.item ? entry.item : {};
      return (entry.isGroup ? 'group-' : 'shared-') + (item.id || this.getSharedNoteId(item));
    },

    getSharedNote(item) {
      return item && item.user_notes ? item.user_notes : {};
    },

    getSharedNoteId(item) {
      return this.getSharedNote(item).id;
    },

    getSharedNoteTitle(item) {
      return this.getSharedNote(item).title || 'Untitled note';
    },

    getSharedNoteCreatedAt(item) {
      return this.getSharedNote(item).created_at || '';
    },

    getSharedNoteOwnerName(item) {
      const user = this.getSharedNote(item).user || {};
      return [user.first_name, user.last_name].filter(Boolean).join(' ');
    },

    handleSharedNoteSelection(entry, isCoreList) {
      const item = entry.item;
      const noteId = this.getSharedNoteId(item);

      if (!noteId) return;

      if (!entry.isGroup && item.write_access === false) {
        this.writeAccessNotesInfoMethod(noteId);
        return;
      }

      if (isCoreList) {
        this.viewCoreShareNotesInfoMethod(noteId, item.is_read, item.id);
      } else {
        this.viewShareNotesInfoMethod(noteId, item.is_read, item.id);
      }
    },

    async performLoadAllNotes(resolveView) {
      this.isLoadingNotes = true;

      try {
        const response = await this.$store.dispatch('getAllNotesListFun');
        const payload = this.getResponseData(response, {});
        const results = this.toArray(payload && payload.results);

        this.getAllNotesList = payload || {};
        this.getAllNotesListResults = results;

        if (resolveView) {
          if (results.length) {
            this.setActiveView(VIEW.LIST);
          } else {
            this.notesBoardInsert = false;
            this.setActiveView(VIEW.CREATE);
          }
        }

        return results;
      } catch (error) {
        this.reportError('Unable to load notes.', error);
        return [];
      } finally {
        this.isLoadingNotes = false;
        this.notesListRequest = null;
      }
    },

    loadAllNotes(options) {
      const resolveView = Boolean(options && options.resolveView);
      if (this.notesListRequest) return this.notesListRequest;

      this.notesListRequest = this.performLoadAllNotes(resolveView);
      return this.notesListRequest;
    },

    async performLoadSharedNotes() {
      this.isLoadingShared = true;

      try {
        const response = await this.$store.dispatch('getAllSharedNotesListFun');
        const payload = this.getResponseData(response, {});

        this.sharedNotesList = payload || {};
        this.sharedNotesListResults = this.toArray(payload && payload.shared_notes);
        this.sharedGroupNotesListResults = this.toArray(payload && payload.grp_shared_notes);

        return this.allSharedNotesResults;
      } catch (error) {
        this.reportError('Unable to load shared notes.', error);
        this.sharedNotesList = {};
        this.sharedNotesListResults = [];
        this.sharedGroupNotesListResults = [];
        return [];
      } finally {
        this.isLoadingShared = false;
        this.sharedNotesRequest = null;
      }
    },

    loadSharedNotes() {
      if (this.sharedNotesRequest) return this.sharedNotesRequest;
      this.sharedNotesRequest = this.performLoadSharedNotes();
      return this.sharedNotesRequest;
    },

    getAllCreatedNotesListMethod() {
      return this.loadAllNotes({ resolveView: true });
    },

    getAgainAllCreatedNotesListMethod() {
      this.sharedNotesSection = false;
      return this.loadAllNotes({ resolveView: true });
    },

    getAgainAllNotesDetailsForUpdateMethod() {
      return this.loadAllNotes({ resolveView: false });
    },

    sharedNotesListMethod() {
      return this.loadSharedNotes();
    },

    async openNoteDetails(noteId, view, readInfo) {
      if (!noteId || this.submitted) return;

      const requestToken = ++this.detailRequestToken;
      this.submitted = true;

      try {
        const response = await this.$store.dispatch('getNotesDetailsByIdFun', { id: noteId });
        if (requestToken !== this.detailRequestToken) return;

        const note = this.getResponseData(response, {});
        this.noteDirty = false;
        this.keyUpEvent = false;
        this.quillInstance = null;

        if (view === VIEW.MY_EDIT) {
          this.notesDetailsUpdatedByIdData = note || {};
        } else {
          this.sharedNotesViewDetails = note || {};
        }

        this.setActiveView(view);

        if (readInfo && readInfo.isRead === false) {
          this.sharedNotesIsReadMethod(readInfo.id);
        }
      } catch (error) {
        this.reportError('Unable to open the note.', error);
      } finally {
        if (requestToken === this.detailRequestToken) {
          this.submitted = false;
        }
      }
    },

    updatedNotesDetailsByIdmethod(noteId) {
      return this.openNoteDetails(noteId, VIEW.MY_EDIT);
    },

    viewShareNotesInfoMethod(noteId, isRead, isReadId) {
      return this.openNoteDetails(noteId, VIEW.SHARED_EDIT, { isRead, id: isReadId });
    },

    viewCoreShareNotesInfoMethod(noteId, isRead, isReadId) {
      return this.openNoteDetails(noteId, VIEW.CORE_SHARED_EDIT, { isRead, id: isReadId });
    },

    writeAccessNotesInfoMethod(noteId) {
      return this.openNoteDetails(noteId, VIEW.READ_ONLY);
    },

    async sharedNotesIsReadMethod(id) {
      if (!id) return;

      try {
        await this.$store.dispatch('isReadNotestStatusFun', {
          user: this.selfUserId,
          grp_shared_notes: id
        });

        const entry = this.allSharedNotesResults.find((item) => item.item.id === id);
        if (entry) this.$set(entry.item, 'is_read', true);
      } catch (error) {
        this.reportError('Unable to mark the shared note as read.', error);
      }
    },

    showSharedUserListMethod() {
      this.sharedNotesSection = !this.sharedNotesSection;
      this.clearNotesFilterMethod();
      if (this.sharedNotesSection) this.loadSharedNotes();
    },

    showSharedUserListNewMethod() {
      this.coreSharedNotesSection = !this.coreSharedNotesSection;
      if (this.coreSharedNotesSection) this.loadSharedNotes();
    },

    async newInsertesNotesBoardMethod() {
      const canLeave = await this.finishEditing();
      if (canLeave === false) return;
      this.notesBoardInsert = true;
      this.coreSharedNotesSection = false;
      this.setActiveView(VIEW.CREATE);
    },

    notesBoardInsertMethod() {
      this.notesBoardInsert = !this.notesBoardInsert;
      if (this.notesBoardInsert) this.coreSharedNotesSection = false;
    },

    hasMeaningfulNoteContent(html) {
      if (!html) return false;
      const text = String(html)
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/gi, ' ')
        .trim();
      return text.length > 0;
    },

    async savedInsertedNotesDataMethod() {
      if (this.submitted) return;

      const title = this.createNotesTitle.trim();
      const hasTitle = title.length > 0;
      const hasContent = this.hasMeaningfulNoteContent(this.createNotesData);

      if (!hasTitle && !hasContent) {
        if (this.getAllNotesListResults.length) {
          this.notesBoardInsert = false;
          this.setActiveView(VIEW.LIST);
        } else {
          this.notesBoardInsert = false;
        }
        return;
      }

      this.submitted = true;

      try {
        await this.$store.dispatch('createNewNotesDetailsFun', {
          data: this.createNotesData,
          title: title || 'Untitled note'
        });

        this.createNotesData = '';
        this.createNotesTitle = '';
        this.notesBoardInsert = false;
        await this.loadAllNotes({ resolveView: true });
      } catch (error) {
        this.reportError('Unable to create the note.', error);
      } finally {
        this.submitted = false;
      }
    },

    markNoteDirty() {
      this.noteDirty = true;
    },

    syncSavedNoteIntoLists(noteId, snapshot) {
      const updateNote = (note) => {
        if (!note || String(note.id) !== String(noteId)) return;
        this.$set(note, 'title', snapshot.title);
        this.$set(note, 'data', snapshot.data);
      };

      this.getAllNotesListResults.forEach(updateNote);

      this.allSharedNotesResults.forEach((entry) => {
        updateNote(this.getSharedNote(entry.item));
      });
    },

    async performCurrentNoteSave(options) {
      const note = this.activeNote;
      if (!note || !note.id || this.isActiveNoteLocked) return;

      const force = Boolean(options && options.force);
      const releaseLock = !options || options.releaseLock !== false;

      if (!force && !this.noteDirty) {
        if (releaseLock) await this.releaseEditingLock(note.id, true);
        return;
      }

      const noteId = note.id;
      const snapshot = {
        data: note.data || '',
        title: (note.title || '').trim() || 'Untitled note'
      };

      this.noteDirty = false;

      try {
        await this.$store.dispatch('updateNewNotesDetailsFun', {
          data: {
            data: snapshot,
            id: noteId
          }
        });

        this.syncSavedNoteIntoLists(noteId, snapshot);
      } catch (error) {
        this.noteDirty = true;
        this.reportError('Unable to save the note.', error);
        throw error;
      }

      if (releaseLock && !this.saveQueued && !this.noteDirty) {
        await this.releaseEditingLock(noteId, true);
      }

      return true;
    },

    saveCurrentNote(options) {
      if (!this.isEditableView) return Promise.resolve(true);

      if (this.saveRequest) {
        if (this.noteDirty || (options && options.force)) {
          this.saveQueued = true;
          this.queuedSaveOptions = options || this.queuedSaveOptions;
        }
        return this.saveRequest;
      }

      const currentOptions = options || {};
      this.saveQueued = false;
      this.queuedSaveOptions = null;

      this.saveRequest = this.performCurrentNoteSave(currentOptions)
        .then(() => true)
        .catch(() => false)
        .then((saved) => {
          const shouldSaveAgain = saved && this.saveQueued;
          const nextOptions = this.queuedSaveOptions || currentOptions;

          this.saveRequest = null;
          this.saveQueued = false;
          this.queuedSaveOptions = null;

          if (shouldSaveAgain) {
            return this.saveCurrentNote({
              force: true,
              releaseLock: nextOptions.releaseLock !== false
            });
          }

          return saved;
        });

      return this.saveRequest;
    },

    updatedInsertedNotesDataMethod(updateData, updateTitle, updateId) {
      if (this.activeNote && String(this.activeNote.id) === String(updateId)) {
        this.$set(this.activeNote, 'data', updateData || '');
        this.$set(this.activeNote, 'title', updateTitle || '');
        this.noteDirty = true;
        return this.saveCurrentNote({ force: true });
      }

      return this.$store.dispatch('updateNewNotesDetailsFun', {
        data: {
          data: {
            data: updateData || '',
            title: (updateTitle || '').trim() || 'Untitled note'
          },
          id: updateId
        }
      }).catch((error) => {
        this.reportError('Unable to save the note.', error);
      });
    },

    async updatedSharedNotesNotificationMethod(updateId) {
      if (!updateId || this.keyUpEvent || this.editLockRequest || this.isActiveNoteLocked) return;

      this.editLockRequest = this.$store.dispatch('updateNewNotesDetailsFun', {
        data: {
          data: {
            under_editing: true,
            edited_by: this.selfUserId
          },
          id: updateId
        }
      });

      try {
        await this.editLockRequest;
        this.keyUpEvent = true;
        this.clearEditorHistory();
      } catch (error) {
        this.reportError('Unable to acquire the note editing lock.', error);
      } finally {
        this.editLockRequest = null;
      }
    },

    async releaseEditingLock(updateId, suppressError) {
      if (!updateId) return;

      if (this.editLockRequest) {
        try {
          await this.editLockRequest;
        } catch (error) {
          // Acquisition failure is already reported by its caller.
        }
      }

      if (!this.keyUpEvent) return;

      try {
        await this.$store.dispatch('updateNewNotesDetailsFun', {
          data: {
            data: {
              under_editing: false,
              edited_by: this.selfUserId
            },
            id: updateId
          }
        });
      } catch (error) {
        if (!suppressError) {
          this.reportError('Unable to release the note editing lock.', error);
        }
      } finally {
        this.keyUpEvent = false;
        this.clearEditorHistory();
      }
    },

    updatedSharedNotesNotificationFalseMethod(updateId) {
      return this.releaseEditingLock(updateId, false);
    },

    async finishEditing(nextView) {
      if (this.isEditableView && this.activeNote && this.activeNote.id) {
        const saved = await this.saveCurrentNote();
        if (saved === false && this.noteDirty) return false;
        await this.releaseEditingLock(this.activeNote.id, true);
      }

      this.noteDirty = false;
      if (nextView) this.setActiveView(nextView);
      return true;
    },

    async handleEditorBack() {
      if (this.activeView === VIEW.MY_EDIT) {
        await this.newInsertesNotesBoardMethod();
      } else if (this.activeView === VIEW.CORE_SHARED_EDIT) {
        await this.backToCoreSharedNotesList();
      } else {
        await this.backToSharedNotesList();
      }
    },

    async handleEditorDone() {
      if (this.activeView === VIEW.CORE_SHARED_EDIT) {
        await this.backToCoreSharedNotesList();
      } else {
        await this.enabledAllNotesListMethod();
      }
    },

    async enabledAllNotesListMethod() {
      return this.finishEditing(VIEW.LIST);
    },

    disabledAllNotesListMethod() {
      if (this.activeView === VIEW.LIST) this.setActiveView(VIEW.CREATE);
    },

    async backToMyNotesList() {
      const canLeave = await this.finishEditing(VIEW.LIST);
      if (canLeave === false) return;
      this.sharedNotesSection = false;
    },

    async backToSharedNotesList() {
      const canLeave = await this.finishEditing(VIEW.LIST);
      if (canLeave === false) return;
      this.sharedNotesSection = true;
      this.loadSharedNotes();
    },

    async backToCoreSharedNotesList() {
      const canLeave = await this.finishEditing(VIEW.CREATE);
      if (canLeave === false) return;
      this.notesBoardInsert = false;
      this.coreSharedNotesSection = true;
      this.loadSharedNotes();
    },

    backToWriteAccessNotesList() {
      this.setActiveView(this.coreSharedNotesSection ? VIEW.CREATE : VIEW.LIST);
      if (this.coreSharedNotesSection) {
        this.notesBoardInsert = false;
      } else {
        this.sharedNotesSection = true;
      }
      this.loadSharedNotes();
    },

    enabledNotesViewPopupMethod(data) {
      this.notesViewData = data || {};
      this.notesViewPopup = true;
    },

    enabledConvertedPdfPopupMethod(data) {
      this.notesConvertPdfData = data || {};
      this.notesConvertPdfState = true;
    },

    sharedNotesPopupEnabledFun(data) {
      this.sharedNotesInfo = data || {};
      this.sharedNotesPopup = true;
    },

    removedInsertedNotesDataMethod(removeId) {
      if (!removeId) return;
      this.notesRemovedId = removeId;
      this.notesRemovedPopup = true;
    },

    closeRemoveItemModalFun() {
      this.notesRemovedId = null;
      this.notesRemovedPopup = false;
    },

    async removeModalItemConfirmFun() {
      if (!this.notesRemovedId || this.submitted) return;

      const id = this.notesRemovedId;
      this.submitted = true;

      try {
        await this.$store.dispatch('deleteNewNotesDetailsFun', { id });
        this.closeRemoveItemModalFun();
        this.notesDetailsUpdatedByIdData = {};
        this.noteDirty = false;
        this.keyUpEvent = false;
        await this.loadAllNotes({ resolveView: true });
      } catch (error) {
        this.reportError('Unable to delete the note.', error);
      } finally {
        this.submitted = false;
      }
    },

    onEditorReady(quill) {
      this.quillInstance = quill || null;
      this.clearEditorHistory();
    },

    // Backward-compatible aliases for any parent refs using the old handlers.
    onMyNotesEditorReady(quill) {
      this.onEditorReady(quill);
    },

    onSharedNotesEditorReady(quill) {
      this.onEditorReady(quill);
    },

    onCoreSharedNotesEditorReady(quill) {
      this.onEditorReady(quill);
    },

    clearEditorHistory() {
      this.$nextTick(() => {
        if (this.quillInstance && this.quillInstance.history) {
          this.quillInstance.history.clear();
        }
      });
    },

    clearNotesFilterMethod() {
      this.notesSearchState = '';
      this.noteCloseState = false;
      this.notesSearchResults = [];
    },

    async notesSearchToKeywordMethod() {
      const query = this.notesSearchState.trim();
      if (!query || this.submitted) {
        this.clearNotesFilterMethod();
        return;
      }

      this.submitted = true;

      try {
        const response = await this.$store.dispatch('notesSearchBarAction', { query });
        const payload = this.getResponseData(response, {});
        this.notesSearchResults = this.toArray(payload && payload.results);
        this.noteCloseState = true;
      } catch (error) {
        this.reportError('Unable to search notes.', error);
      } finally {
        this.submitted = false;
      }
    },

    handleNotesViewPopupBus(value) {
      this.notesViewPopup = Boolean(value);
      if (!this.notesViewPopup) {
        this.loadAllNotes({ resolveView: false });
        if (this.sharedNotesList) this.loadSharedNotes();
      }
    },

    handleSharedNotesBus(value) {
      this.sharedNotesPopup = Boolean(value);
      if (!this.sharedNotesPopup) {
        this.loadAllNotes({ resolveView: false });
        if (this.sharedNotesList) this.loadSharedNotes();
      }
    },

    handleNotesConvertPdfStateBus(value) {
      this.notesConvertPdfState = Boolean(value);
    }
  }
};
</script>

<style lang="scss" scoped>
.notes_board_main_wrp {
    height: 100%;
    position: relative;
    background-image: url("../../../../assets/images/paper_texture.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    border-radius: 5px;
}

.todo_content_inner_wrp {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.todo_content_inner_wrp.new_inserted_notes_board_wrp {
    z-index: 110;
}

.no_notes_msg_wrp {
    display: flex;
    align-items: center;
    height: calc(100% - 32px);
    justify-content: center;
}

.no_notes_msg {
    font-weight: normal;
    color: #4d4d4d;
    font-size: 19px;
    margin: 0;
    font-family: 'simplicitymedium';
    width: 100%;
    text-align: center;
    line-height: 1.4;
}

.todo_notes_header_wrp {
    padding: 0px;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px 5px 0px 0px;
    overflow: hidden;
}

.todo_notes_header_wrp .todo_notes_insert_icon {
    padding: 5px 10px;
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
}

.todo_notes_header_wrp .todo_notes_insert_icon:hover {
    background-color: rgba(0, 0, 0, 0.1);
}

.todo_notes_header_wrp .todo_notes_insert_icon:active {
    background-color: rgba(0, 0, 0, 0.1);
}

.add_new_notes {
    filter: invert(1);
    -webkit-filter: invert(1);
    cursor: pointer;
}

.notes_textarea_wrp {
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding: 10px 10px 0px;
}

.notes_textarea_wrp .title_insert_notes_textarea {
    width: 100%;
    border: none;
    resize: none;
    background: none;
    outline: none;
    font-size: 22px;
    font-weight: 500;
    font-family:'MyriadProRegular', 'Lato', sans-serif;
    line-height: 1.1;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    padding: 10px 0;
    color: #660000;
}

.notes_textarea_wrp .title_insert_notes_textarea::-moz-placeholder {
    color: rgba(0, 0, 0, 0.3);
}

.notes_textarea_wrp .title_insert_notes_textarea::-webkit-input-placeholder {
    color: rgba(0, 0, 0, 0.3);
}

.notes_textarea_wrp .data_insert_notes_textarea {
    width: 100%;
    height: 85%;
    border: none;
    resize: none;
    background: none;
    outline: none;
    font-size: 18px;
    font-weight: 600;
    font-family: 'simplicitymedium';
    letter-spacing: 1px;
    padding: 10px 0px;
    white-space: break-spaces;
}

.notes_textarea_wrp .data_insert_notes_textarea::-moz-placeholder {
    color: rgba(0, 0, 0, 0.5);
}

.notes_textarea_wrp .data_insert_notes_textarea::-webkit-input-placeholder {
    color: rgba(0, 0, 0, 0.5);
}

.notes_textarea_wrp .data_insert_notes_textarea::-webkit-scrollbar {
    width: 5px;
    background: none;
}

.notes_textarea_wrp .data_insert_notes_textarea::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.18);
}

.todo_notes_insert_icon .fa {
    font-size: 22px;
    vertical-align: middle;
    color: #000;
    cursor: pointer;
}

.todo_notes_insert_icon .fa.fa-align-right {
    transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
}

.remove_notes_task_modal {
    position: fixed;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.92);
    left: 0;
    right: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
}

.remove_notes_task_modal .remove_notes_task_modal_body {
    background: #000;
    width: 480px;
    margin: 0px auto;
    border-radius: 5px;
    padding: 20px 25px;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    color: #ffffff;
    -webkit-box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
    box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6)
}

.remove_notes_task_modal .remove_notes_task_header h2 {
    font-size: 18px;
    color: #ffffff;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    text-align: center;
    margin: 0 0 30px;
}

.remove_notes_task_modal .remove_yes_btn {
    font-size: 16px;
    background: rgba(33, 228, 0, 0.5);
    color: #fff;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    padding: 10px 5px;
    min-width: 100px;
    line-height: 1;
    border-radius: 3px !important;
    outline: none !important;
    box-shadow: none !important;
    &:hover{
        background: #ffe738 !important;
        color: #22292f !important;
    }
}

.remove_notes_task_modal .remove_yes_no {
    font-size: 16px;
    background: rgba(255, 18, 18, 0.5);
    color: #fff;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    padding: 10px 5px;
    min-width: 100px;
    line-height: 1;
    margin-left: 15px;
    border-radius: 3px !important;
    outline: none !important;
    box-shadow: none !important;
    &:hover{
        background: #ffe738 !important;
        color: #22292f !important;
    }
}

.remove_notes_task_modal .remove_notes_task_btn {
    text-align: center;
}

.notes_list_items {
    padding: 10px 15px;
    height: calc(100% - 32px);
    margin: 0;
    overflow-y: auto;
}

.notes_list_items::-webkit-scrollbar {
    width: 5px;
    background: none;
}

.notes_list_items::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.18);
}

.notes_list_items li {
    font-size: 20px;
    color: #000000;
    position: relative;
    font-family: 'simplicitymedium';
    font-weight: bold;
    letter-spacing: 1px;
    margin-bottom: 0px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    padding: 0px 30px;
    cursor: pointer;
}

.notes_list_items li.alert_msg_shared_notes {
    margin: 15px 0 0;
    border: none;
    padding: 0;
    text-align: center;
}

.notes_list_items li .fa {
    position: absolute;
    left: 0;
    top: 10px;
}

.notes_list_items li .fa.fa-share-alt {
    top: 50%;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    color: #383838;
}

.notes_list_items li .notes_list_itemwrp {
    padding: 10px 0px;
}

.notes_list_items li .notes_sharing_icon .fa {
    left: auto;
    right: 0px;
    font-size: 22px;
}

.notes_list_items li .notes_sharing_icon .fa:hover {
    color: #7e009a;
}

.notes_list_items li span {
    display: block;
}

.notes_list_items li span.notes_title_span {
    line-height: 1.2;
    margin-bottom: 2px;
}

.notes_list_items li span.shared_notes_user_name {
    color: #660000;
    font-size: 14px;
    font-weight: 600;
    margin-top: 2px;
}

.notes_list_items li .notes_created_date {
    font-weight: normal;
    font-size: 13px;
}

.notes_created_date {
    color: #7e009a;
    font-size: 16px;
    line-height: 1;
    display: block;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
}

.shared_notes_toolbar .btn-primary,
.shared_notes_toolbar .btn-primary:focus {
    padding: 4px 8px;
    font-size: 15px;
    border-radius: 70px;
    background: rgba(0, 0, 0, 0.8);
    color: #ffd400;
    border: none;
    margin-right: 5px;
    text-transform: capitalize;
    font-weight: 400;
    line-height: 1;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    outline: none !important;
    box-shadow: none !important;
    transition: all 0.8s ease;
    -webkit-transition: all 0.8s ease;
    -moz-transition: all 0.8s ease;
}

.shared_notes_toolbar .btn-primary:hover,
.shared_notes_toolbar .btn-primary:focus:hover {
    background: #87cefa;
    color: #000000;
}

.notes_loader {
    text-align: center;
    padding-top: 30px;
}

.notes_loader .img-fluid {
    width: 50px;
}

.currently_updating_txt {
    color: #100052;
    font-size: 14px;
    line-height: 1.2;
    display: block;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    background: linear-gradient(-30deg, rgba(147, 91, 4, 0.5) 0%, rgba(234, 187, 111, 0.5) 50%, rgba(190, 125, 40, 0.5) 50%, rgba(255, 203, 119, 0.5) 100%);
    border: 1px solid #dbc068;
    border-radius: 5px;
    padding: 3px 8px;
}

.new_notes_label {
    margin: 0;
    background: #8b0000;
    color: #fff0d9;
    padding: 0px 7px;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    font-weight: normal;
    line-height: 20px;
    border-radius: 2px;
    position: absolute;
    top: 10px;
    right: 0;
}

.notes_list_items li span.note_html_title {
    line-height: 1;
    margin-bottom: 5px;
}

.shared_notes_view_wrp {
    background-image: url("../../../../assets/images/paper_texture.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    border-radius: 5px;
}

.notes_list_items.shared_notes_list_wrp>li {
    padding: 8px 30px;

    &.alert_msg_shared_notes {
        padding: 0px;
    }
}

.notes_searchbar_box {
    position: relative;
    height: 52px;

    .fa {
        position: absolute;
        top: 48%;
        color: rgba(255, 255, 255, 0.2);
        font-size: 25px;
        transform: translate(17px, -50%);
        &.fa-times {
            left: auto;
            right: 28px;
            color: #ff1a32;
            cursor: pointer;
            &:hover{color:#87cefa;}
        }
    }

    input {
        height: 100%;
        width: 100%;
        height: 52px;
        font-weight: normal;
        font-size: 18px;
        border-radius: 5px;
        padding: 0 20px 0 53px;
        border: 2px solid rgba(255, 255, 255, 0.12);
        background: none;
        outline: none !important;
        box-shadow: none !important;
        color: #ffc107;
        background:#383633;

        &:focus,
        &.active {
            border: 2px solid #ffd400;
            // background: rgba(56, 56, 56, 1);
        }

        &::placeholder,
        &::-webkit-input-placeholder,
        &::-moz-placeholder {
            color: rgba(255, 255, 255, 0.1);
        }
    }
}

.shared_toolbar_inline {
    display: inline-block;
}

.icon_button {
    border: 0;
    background: transparent;
    line-height: 1;
    outline: none !important;
}

.icon_button:disabled,
.notes_item_button:disabled {
    cursor: not-allowed;
    opacity: 0.55;
}

.notes_item_button {
    display: block;
    width: 100%;
    padding: 10px 0;
    border: 0;
    background: transparent;
    color: inherit;
    font: inherit;
    text-align: left;
    outline: none !important;
}

.notes_list_items.shared_notes_list_wrp .notes_item_button {
    padding: 0;
}

.notes_empty_state {
    border: none !important;
    padding: 15px 0 !important;
    text-align: center;
    cursor: default !important;
}

.notes_loading_state {
    border: none !important;
    padding: 30px 0 !important;
    text-align: center;
    cursor: default !important;
}

.notes_loading_state img {
    width: 50px;
}

.notes_sharing_icon {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 30px;
}

.notes_sharing_icon .icon_button {
    width: 100%;
    height: 100%;
    padding: 0;
}

.notes_sharing_icon .fa {
    pointer-events: none;
}

.readonly_html_note_text {
    height: calc(100% - 55px);
    overflow-y: auto;
    overflow-wrap: anywhere;
}

.remove_notes_task_modal_body {
    max-width: calc(100% - 30px);
}

.no_write_access_label {
    color: #e60303;
    font-size: 16px;
    font-weight: 500;
}

</style>